export const getStyle = state => state.workspace.style;
